/**
 * Flattens the answer of `GET /api/patients/:nhsId`.
 *
 * The endpoint answers `{ clinicalFile: { details: { … } } }`, with the name,
 * birth date, email and tax number all inside `details`. Screens read plain
 * fields, so `details` is flattened over the file.
 *
 * The file's own `id` is kept last on purpose: `details.id` identifies the
 * details row, not the clinical file, and the clinical file id is what the
 * payments API expects as a transaction's `receiver`.
 */
export function normalizePatient(response: any) {
  const file = response?.clinicalFile ?? response;
  if (!file) return null;
  return { ...file, ...(file.details ?? {}), id: file.id };
}

/**
 * Reads the patient's tax number defensively.
 *
 * `GET /api/patients/:nhsId` carries it as `details.fiscalId`, the same place
 * the mobile app reads it from. It is an optional field, so a patient who never
 * registered one simply has none.
 */
export function extractPatientFiscalId(patient: any): string | undefined {
  const value = patient?.fiscalId ?? patient?.details?.fiscalId ?? patient?.nif;
  return typeof value === "string" && value.length > 0 ? value : undefined;
}
